module.exports = __webpack_public_path__ + "static/media/IMG_6081.aacf8c1d.HEIC";